import {MutationBulkDomainNonPaymentBlockingArgs, NonPaymentBlockingType} from "@/api";

export function createInitialData(domainId: number): MutationBulkDomainNonPaymentBlockingArgs {
    return {
        id: domainId,
        value: NonPaymentBlockingType.NotBlocked,
    };
}
